import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme: Theme) => ({
  containerNotification: {
    display: 'flex',
    flexDirection: 'column',
    width: 400,
    backgroundColor: '#FFFFFF',
    borderRadius: '0px 0px 4px 4px',
    [theme.breakpoints.down(430)]: {
      width: '100vw',
      maxWidth: '100%',
    },
  },
  buttonNotification: {
    all: 'unset',
    cursor: 'pointer',
    borderRadius: '100%',
    display: 'flex',
    alignItems: 'center',
    color: '#0467B8',
    justifyContent: 'center',
    position: 'relative',
    width: 48,
    height: 48,
  },
  indicatorNotificationNotViewedIcon: {
    width: 8,
    height: 8,
    backgroundColor: '#F03D3D',
    borderRadius: '100%',
  },
  contentNotificationTitle: {
    width: '100%',
    height: 48,
    marginBottom: 8,
    padding: '0px 12px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down(430)]: {
      padding: '0px 8px',
    },
  },
  notificationText: {
    fontSize: 16,
    fontWeight: 700,
    color: '#333333',
    fontFamily: 'Roboto',
    [theme.breakpoints.down(430)]: {
      fontSize: 14,
    },
  },
  markAllNotificationText: {
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 500,
    color: theme.palette.primary.main,
    textTransform: 'uppercase',
    fontFamily: 'Roboto',
    [theme.breakpoints.down(430)]: {
      fontSize: theme.typography.pxToRem(10),
    },
  },
  gridMain: {
    display: 'grid',
    width: '100%',
    gridTemplateRows: 'repeat(3,80px)',
    [theme.breakpoints.down(430)]: {
      gridTemplateRows: 'repeat(3,auto)',
    },
  },
  textAlert: {
    fontSize: theme.typography.pxToRem(18),
    color: '#333',
    fontFamily: 'Roboto',
    fontWeight: 500,
    padding: '20px',
    textAlign: 'center',
    [theme.breakpoints.down(430)]: {
      fontSize: theme.typography.pxToRem(16),
      padding: '15px',
    },
  },
  iconProgress: {
    fontSize: theme.typography.pxToRem(50),
    color: theme.palette.primary.main,
  },
  cardNotification: {
    all: 'unset',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flex: 1,
    borderBottom: '1px #EAECF0 solid',
    paddingBlock: 16,
    paddingInline: 24,
    [theme.breakpoints.down(430)]: {
      paddingInline: 12,
    },
    '&:hover': {
      cursor: 'pointer',
      background: theme.palette.primary.main,
      '& .titleMainCard': {
        color: '#FFFFFF',
      },
      '& .subTitleMainCard': {
        color: 'rgba(255,255,255, 0.8)',
      },
      '& .boxIconMessageNotification': {
        background: '#FFFFFF',
      },
      '& .iconNotify': {
        color: '#053396',
      },
    },
  },
  itemMessageNotification: {
    display: 'flex',
    flexDirection: 'row',
    gap: 16,
    alignItems: 'center',
    [theme.breakpoints.down(430)]: {
      gap: 8,
    },
  },
  boxIconMessageNotification: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: 40,
    minWidth: 40,
    height: 40,
    borderRadius: '100%',
    [theme.breakpoints.down(430)]: {
      width: 32,
      minWidth: 32,
      height: 32,
    },
  },
  iconNotify: {
    color: '#053396',
  },
  titleMainCard: {
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(16),
    color: '#1D2939',
    pointerEvents: 'none',
    transition: 'color 0.3 ease',
    [theme.breakpoints.down(430)]: {
      fontSize: theme.typography.pxToRem(14),
    },
  },
  boxInformationNotification: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: 4,
  },
  subTitleMainCard: {
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(13),
    color: 'rgba(29,41,57,0.8)',
    transition: 'color 0.3 ease',
    [theme.breakpoints.down(430)]: {
      fontSize: theme.typography.pxToRem(11),
    },
  },
  asideLeftIcon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: 16,
  },
  indicatorNotificationViewedIcon: {
    width: 8,
    height: 8,
    backgroundColor: '#0467B8',
    borderRadius: '100%',
  },
  indicatorNotificationNotViewed: {
    position: 'absolute',
    top: 10,
    right: 8,
    width: 8,
    height: 8,
    backgroundColor: '#F03D3D',
    borderRadius: '100%',
  },
  footerNotify: {
    all: 'unset',
    cursor: 'pointer',
    display: 'flex',
    width: '100%',
    height: 48,
    alignItems: 'center',
    justifyContent: 'center',
  },
  footerTitleNotify: {
    fontSize: theme.typography.pxToRem(13),
    fontWeight: 400,
    background: theme.palette.primary.main,
    backgroundClip: 'text',
    '-webkit-background-clip': 'text',
    color: 'transparent',
  },
}))
